import { render, staticRenderFns } from "./WkUploadCell.vue?vue&type=template&id=9f2fd2f2&scoped=true&"
import script from "./WkUploadCell.vue?vue&type=script&lang=js&"
export * from "./WkUploadCell.vue?vue&type=script&lang=js&"
import style0 from "./WkUploadCell.vue?vue&type=style&index=0&id=9f2fd2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2fd2f2",
  null
  
)

component.options.__file = "WkUploadCell.vue"
export default component.exports